module.exports = __webpack_public_path__ + "static/media/dmb-2.d4b92de8.jpg";